<sf-card icon="shopping-cart" cardTitle="Previously Placed Orders">
    <p class="text-body-secondary">View orders previously placed using Surefire.</p>
    <div class="row">
        <div class="col-md-6">
            <sf-calendar-range-selector
                [startDate]="filter().from!"
                [endDate]="filter().to!"
                (dateRangeChange)="onDateChanged($event)">
            </sf-calendar-range-selector>
        </div>
    </div>
    @if (orders.hasValue()) {
        <sf-orders-table [orders]="orders.value()!.items"></sf-orders-table>
        <sf-pagination-detail
            [paginationData]="orders.value()!"
            (onPageChange)="onPageChanged($event)"></sf-pagination-detail>
    }
</sf-card>
